import React from 'react';
import { useHistory } from 'react-router-dom';

// Material UI
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

// Data
import { APP_TITLE } from '../../../../../_configuration';

// Components
import { PrimaryButton } from '../../../_core/_ui/buttons.component';
import { Logo } from '../../../_core/_ui/general.components';
import { Text } from '../../../_core/_ui/typography.component';
import { useCompanyLogo } from '../../../../lib/stores/company.store';

interface INotFoundPage {
  // The home destination for whichever app tree this 404 was reached from.
  // Caller (App.tsx) supplies HOME_ROUTE for staff, PARENT_HOME_ROUTE for parent.
  homeTo: string;
}

export const NotFoundPage: React.FC<INotFoundPage> = ({ homeTo }) => {
  const history = useHistory();
  const logo = useCompanyLogo();

  return (
    <Container>
      <Grid container spacing={3} justifyContent="center" alignItems="center">
        <Grid container item xs={12} justifyContent="center" alignItems="center">
          <Logo src={logo} alt={APP_TITLE} />
        </Grid>
        <Grid item xs={12}>
          <Text large align="center">Could not find the content you were looking for (404)</Text>
        </Grid>
        <Grid container item xs={12} justifyContent="center">
          <Box mt={2}>
            <PrimaryButton variant="contained" onClick={() => history.push(homeTo)}>
              Go to home
            </PrimaryButton>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};
